import { Radio, RadioGroup, RadioProvider } from '@ariakit/react'
import * as React from 'react'

import { EmbroideryIcon } from '../../../../../../containers/EmbroideryContainer/useEmbroideryDesigns'
import { SelectionGroup } from '../../shared-form-styles'

import { IconButton, StyledResponsiveImage } from './styles'

export const IconSelector: React.FC<{
  icons: Array<EmbroideryIcon>
  labelId: string
  onSelectIcon(iconImage: EmbroideryIcon): void
  productColorHex: string | undefined
  selectedIcon: EmbroideryIcon | undefined | null
}> = ({ icons, labelId, onSelectIcon, selectedIcon, productColorHex: backgroundColor }) => {
  return (
    <>
      <RadioProvider
        value={selectedIcon?.key ?? null}
        setValue={key => {
          const icon = icons.find(i => i.key === key)
          if (icon) onSelectIcon(icon)
        }}
      >
        <RadioGroup render={<SelectionGroup aria-labelledby={labelId} />}>
          {icons.map(icon => (
            <Radio
              key={icon.id}
              value={icon.key}
              render={
                <IconButton isSelected={selectedIcon?.key === icon.key} type='button'>
                  <StyledResponsiveImage
                    backgroundColor={backgroundColor}
                    alt={icon.image.altText || icon.image.label}
                    src={icon.image.src}
                    widths={{ unit: 'px', sm: 50, md: 60 }}
                    aspectRatios={{ sm: 1, md: 1 }}
                    loading='default'
                  />
                </IconButton>
              }
            />
          ))}
        </RadioGroup>
      </RadioProvider>
    </>
  )
}
